import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { getFieldOnMainLanguage } from './languages';
import { makeCommaSeparatedString } from './stringUtils';

interface TaxonomyLink {
  id: string;
  getName(value: number): string | null;
}

export const getTaxonomyFullName = (selectedTaxonomy: GenericObject | null) => {
  let titleArray = [];
  if (selectedTaxonomy?.great_grand_parent_category_name) {
    titleArray.push(getFieldOnMainLanguage(selectedTaxonomy.great_grand_parent_category_name));
  }

  if (selectedTaxonomy?.grand_parent_category_name) {
    titleArray.push(getFieldOnMainLanguage(selectedTaxonomy.grand_parent_category_name));
  }

  if (selectedTaxonomy?.parent_category_name) {
    titleArray.push(getFieldOnMainLanguage(selectedTaxonomy.parent_category_name));
  }

  if (selectedTaxonomy?.category_name) {
    titleArray.push(getFieldOnMainLanguage(selectedTaxonomy.category_name));
  }

  return titleArray.length > 1 ? titleArray.join(' / ') : titleArray.join();
};

const taxonomyLinks = [
  {
    id: 'companies',
    getName: (companies: number) => (!companies ? null : `${companies} ${companies > 1 ? 'companies' : 'company'}`),
  },
  {
    id: 'experts',
    getName: (experts: number) => (!experts ? null : `${experts} ${experts > 1 ? 'experts' : 'expert'}`),
  },
  { id: 'media', getName: (media: number) => (!media ? null : `${media} media`) },
  { id: 'series', getName: (series: number) => (!series ? null : `${series} series`) },
];

export const formatDeleteMessageWithLinks = (links: GenericObject) => {
  const existingLinks: string[] = [];

  taxonomyLinks.forEach((link: TaxonomyLink) => {
    const linkName = link.getName(links[link.id] as number);
    if (linkName) {
      existingLinks.push(linkName);
    }
  });

  if (!existingLinks.length && !links.relatedTopics && !links.followers) {
    return null;
  }

  const message = {
    header: 'Before deleting this topic, please consider the following associations:',
    links: '',
    relatedTopics: '',
    followers: '',
    footer:
      'Deleting this topic will remove these associations and will no longer appear in subscribers Follow list. Are you sure you want to delete this topic?',
  };

  if (existingLinks.length) {
    const existingLinksMessageSeparatedByCommas = makeCommaSeparatedString(existingLinks);
    message.links = ` Linked to ${existingLinksMessageSeparatedByCommas}`;
  }

  if (links.relatedTopics) {
    message.relatedTopics = ` Related to ${links.relatedTopics} other topics`;
  }

  if (links.followers) {
    message.followers = ` Included in ${links.followers} subscribers Follow list`;
  }

  return message;
};
